import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import useTable from "../../useTable";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import { Toasts } from "../../toasts";
import { PrimaryButton } from "../../../ui/buttons/Button";
import { SearchInput } from "../../../ui/inputs/Input";
import { ModalGestionDeuda2 } from "./modalGestionarDeuda2";

const TablaActualizarDeuda2 = (props) => {
    let op = require("../../../../src/modulos/datos");
    const token = localStorage.getItem("jwtToken");
    const [factorCambio, setFactorCambio] = useState(0);
    const [permiso] = useState({
        permiso: ""
    });

    const headCells =
        props.tipo === "publicidad" || props.tipo === "apuesta" || props.tipo === "licores"
            ? [
                {
                    id: "idcomercio",
                    label: "CODIGO",
                    width: "10px",
                    textAlign: "center",
                    backgroundColor: "rgba(5, 81, 130, 1)",
                    fontSize: "10px",
                    color: "white",
                },
                {
                    id: "ritm",
                    label: "RITM",
                    width: "40px",
                    textAlign: "center",
                    backgroundColor: "rgba(5, 81, 130, 1)",
                    fontSize: "10px",
                    color: "white",
                },
                {
                    id: "rif",
                    label: "RIF",
                    width: "40px",
                    textAlign: "center",
                    backgroundColor: "rgba(5, 81, 130, 1)",
                    fontSize: "10px",
                    color: "white",
                },
                {
                    id: "nombre",
                    label: "NOMBRE",
                    width: "300px",
                    textAlign: "center",
                    backgroundColor: "rgba(5, 81, 130, 1)",
                    fontSize: "10px",
                    color: "white",
                },
                {
                    id: "direccion",
                    label: "DIRECCIÓN",
                    width: "200px",
                    textAlign: "center",
                    backgroundColor: "rgba(5, 81, 130, 1)",
                    fontSize: "10px",
                    color: "white",
                },
                {
                    id: "accion",
                    label: "OPCIONES",
                    width: "80px",
                    textAlign: "center",
                    backgroundColor: "rgba(5, 81, 130, 1)",
                    fontSize: "10px",
                    color: "white",
                },
            ]
            : [];

    const txtBuscador = useRef();
    const [mostrar2, setMostrar2] = useState(false);
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [contribuyente] = useState({
        idcontribuyente: "",
        nombre: "",
        ritm: "",
        rif: "",
        direccion: "",
        status: "",
    });
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: "",
        titulo: "",
    });

    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });

    const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
        useTable(records, headCells, filterFn);

    const handleSearch = (e) => {
        let target = e.target;
        setFilterFn({
            fn: (items) => {
                if (target.value === "") return items;
                else
                    return items.filter((x) => {
                        if (
                            props.tipo === "comercio" ?
                                x.idcomercio.includes(target.value) ||
                                (x.ritm !== null ? x.ritm.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                                x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
                                x.direccion.toLowerCase().includes(target.value.toLowerCase()) ||
                                x.reprelegal.toLowerCase().includes(target.value.toLowerCase()) ||
                                x.rif.toLowerCase().includes(target.value.toLowerCase())
                                : props.tipo === "inmueble" ?
                                    x.idinmueble.includes(target.value) ||
                                    (x.numficha !== null ? x.numficha.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                                    (x.nombrepropie !== null ? x.nombrepropie.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                                    (x.dirinmueble !== null ? x.dirinmueble.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                                    x.codigocatastral.toLowerCase().includes(target.value.toLowerCase()) ||
                                    (x.cedulapropie !== null ? x.cedulapropie.toLowerCase().includes(target.value.toLowerCase()) : "")
                                    : props.tipo === "vehiculo" ?
                                        x.idvehiculo.includes(target.value) ||
                                        x.placa.toLowerCase().includes(target.value.toLowerCase()) ||
                                        (x.ritm !== null ? x.ritm.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                                        x.nombrepropie.toLowerCase().includes(target.value.toLowerCase())
                                        : props.tipo === "rentas" ?
                                            x.idrentas.includes(target.value) ||
                                            x.cedrif.toLowerCase().includes(target.value.toLowerCase()) ||
                                            x.nombrearrendatario.toLowerCase().includes(target.value.toLowerCase()) ||
                                            x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                                            : props.tipo === "publicidad" || props.tipo === "apuesta" || props.tipo === "licores" ?
                                                x.idcomercio.includes(target.value) ||
                                                (x.ritm !== null ? x.ritm.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                                                x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
                                                x.direccion.toLowerCase().includes(target.value.toLowerCase()) ||
                                                x.rif.toLowerCase().includes(target.value.toLowerCase())
                                                : ""


                        ) {
                            return x;
                        }
                    });
            },
        });
    };

    const cerrarToast = () => {
        setToast({
            mostrar: false,
        });
    };

    const handleCancela2 = () => {
        setMostrar2(false);
    };

    const seleccionarPublicidad = () => {
        let campos = "DISTINCT c.codigocatastral, c.idcomercio, c.nombre, c.rif, c.ritm, c.reprelegal, c.fechainscripcion, c.cuenta, c.direccion, c.esagentereten, c.actualizado, c.status, s.descripcion as descristatus";
        let nomtab = 'publicidad p, comercio c, status s';
        let condi = 'c.idcomercio = p.idcomercio AND s.idstatus = c.status';
        let orden = 'idcomercio';
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    setRecords(response.data);
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });

                setActivate(false);
            });
    };

    const seleccionarLicores = () => {

        let campos = "DISTINCT c.codigocatastral, c.idcomercio, c.nombre, c.rif, c.ritm, c.reprelegal, c.fechainscripcion, c.cuenta, c.direccion, c.esagentereten, c.actualizado, c.status, s.descripcion as descristatus ";
        let nomtab = 'licores l, comercio c, status s';
        let condi = 'c.idcomercio = l.idcomercio AND s.idstatus = c.status';
        let orden = 'idcomercio';
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            }
        }).then(function (response) {

            if (response.status === 200) {
                setRecords(response.data);
            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    }

    const seleccionarFactorCambio = () => {

        let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)
                setFactorCambio(response.data.valor)

            }

        }).catch(function (error) {

            /*   setTitulo("ERROR");
              setMsg(error.response.data.message)
              setMostrar5(true)*/
            setActivate(false);

        })
    }

    useEffect(() => {
        seleccionarFactorCambio();
    }, []);

    useEffect(() => {
        txtBuscador.current.value = "";
        if (props.tipo === "publicidad") {
            permiso.permiso = JSON.parse(localStorage.getItem("accactudeuindustria"));
            seleccionarPublicidad();
        } else if (props.tipo === "licores") {
            permiso.permiso = JSON.parse(localStorage.getItem("accactudeuindustria"));
            seleccionarLicores()
        }
    }, [props.tipo]);

    const gestionarDeuda = (data) => (event) => {
        event.preventDefault();
        contribuyente.idcontribuyente = "";
        contribuyente.nombre = "";
        contribuyente.rif = "";
        contribuyente.ritm = "";
        contribuyente.direccion = "";
        if (permiso.permiso !== "" && parseInt(permiso.permiso) !== 0) {
            if (props.tipo === "publicidad" || props.tipo === "licores") {
                /*if (data.status === "52") {
                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Al contribuyente no se le puede cargar deuda, esta inactivo', icono: 'informacion' });
                    return;
                } else if (data.status === "57") {
                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Al contribuyente no se le puede cargar deuda, esta inactivo', icono: 'informacion' });
                    return;
                }*/
                contribuyente.idcontribuyente = data.idcomercio;
                contribuyente.nombre = data.nombre.trim();
                contribuyente.rif = data.rif.trim();
                contribuyente.ritm = data.ritm === null ? "" : data.ritm.trim();
                contribuyente.direccion = data.direccion === null ? "" : data.direccion.trim();
                contribuyente.status = data.descristatus === null ? "" : data.descristatus.trim();
            } 
            setMostrar2(true);
        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para consultar un Contribuyente de actividades Economicas",
            });
        }
    };

    return (
        <div className="col-md-9 mx-auto">
            <div className="card col-md-12 mx-auto">
                <div className="card-body col-md-12">
                    <header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top text-light">
                        {props.tipo === "apuesta" ? (
                            <h3>Actualizar Deuda Apuestas Licitas</h3>
                        ) : props.tipo === "publicidad" ? (
                            <h3>Actualizar Deuda Propaganda y Públicidad Comercial</h3>
                        ) : props.tipo === "licores" ? (
                            <h3>Actualizar Deuda Rentas de Licores</h3>
                        ) : (
                            ""
                        )}
                        <a type="button" className="text-light fw-bold fs-6">
                            Salir <i className="fa fa-times ms-2"></i>
                        </a>
                    </header>
                    <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
                        <div className="col-4 m-0 p-0">
                            <SearchInput
                                ref={txtBuscador}
                                onChange={handleSearch}
                                placeholder="Buscar"
                            />
                        </div>
                        <div className="col-auto m-0 p-0">
                            {props.tipo === "apuesta" &&
                                <PrimaryButton icon='fa-pen'>
                                    Actualizar General
                                </PrimaryButton>
                            }
                        </div>
                    </div>
                    <div className='col-12 m-0 p-0'>

                        {props.tipo === "publicidad" ?
                            <TblContainer>
                                <TblHead />
                                <tbody>
                                    {records &&
                                        recordsAfterPagingAndSorting().map((item, index) => (
                                            <tr key={item.idcomercio} style={{ padding: "0" }}>
                                                <td className="align-baseline text-center">
                                                    {item.idcomercio}
                                                </td>
                                                <td className="align-baseline text-center">
                                                    {item.ritm}
                                                </td>
                                                <td className="align-baseline text-center">
                                                    {item.rif}
                                                </td>
                                                <td className="align-baseline text-center">
                                                    {item.nombre}
                                                </td>
                                                <td className="align-baseline text-center">
                                                    {item.direccion}
                                                </td>

                                                <td
                                                    className="align-baseline text-center"
                                                    style={{ width: "150px" }}
                                                >
                                                    <button
                                                        onClick={gestionarDeuda(item)}
                                                        className="btn btn-sm btn-primary rounded-pill"
                                                    >
                                                        <i class="fas fa-pen-nib"></i> Actualizar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </TblContainer> :
                            props.tipo === "licores" ?
                                <TblContainer>
                                    <TblHead />
                                    <tbody>
                                        {records &&
                                            recordsAfterPagingAndSorting().map((item, index) => (
                                                <tr key={item.idcomercio} style={{ padding: "0" }}>
                                                    <td className="align-baseline text-center">
                                                        {item.idcomercio}
                                                    </td>
                                                    <td className="align-baseline text-center">
                                                        {item.ritm}
                                                    </td>
                                                    <td className="align-baseline text-center">
                                                        {item.rif}
                                                    </td>
                                                    <td className="align-baseline text-center">
                                                        {item.nombre}
                                                    </td>
                                                    <td className="align-baseline text-center">
                                                        {item.direccion}
                                                    </td>

                                                    <td
                                                        className="align-baseline text-center"
                                                        style={{ width: "150px" }}
                                                    >
                                                        <button
                                                            onClick={gestionarDeuda(item)}
                                                            className="btn btn-sm btn-primary rounded-pill"
                                                        >
                                                            <i class="fas fa-pen-nib"></i> Actualizar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </TblContainer> : ''
                        }
                        <TblPagination />
                    </div>
                    <ModalGestionDeuda2
                        show={mostrar2}
                        contribuyente={contribuyente}
                        onHide={handleCancela2}
                        factorcambio={factorCambio}
                        tipo={props.tipo}
                        permiso={permiso.permiso}
                    />
                    <Mensaje
                        mensaje={mensaje}
                        onHide={() =>
                            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
                        }
                    />
                </div>
            </div>
            <Dimmer active={activate} />
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}
            />
        </div>
    );
};
export default TablaActualizarDeuda2;
